import { parseApiError } from '@app/shared/models/api/api-error.model';

export type DeliveryStatus =
  | 'CANCELLED'
  | 'CONFIRMED'
  | 'UNCONFIRMED'
  | 'WAITING_PAYMENT'
  | 'DELIVERING'
  | 'DELIVERED'
  | 'PROCESSING'
  | 'FAILED';

export type DeliveryStatusIcons =
  | 'streamline:shipment_remove'
  | 'streamline:credit_card_payment'
  | 'streamline:style_one_pin_check'
  | 'streamline:shipment_delivered'
  | 'streamline:delivery_person_motorcycle_1'
  | 'streamline:warehouse_cart_packages_2'
  | 'streamline:trip_pins';

export type DeliveryApiErrorType =
  | 'address'
  | 'delivery'
  | 'order'
  | 'provider'
  | 'listing'
  | 'product'
  | 'payment'
  | 'application';

export const POPSY_ORDER_ID_LENGTH = 36;

export const parseDeliveryError = (error: string): DeliveryApiError | null => {
  let message: DeliveryApiError | null = null;

  if (
    error === 'DELIVERY_ORDER_SELLER_INVALID_LOCATION' ||
    error === 'DELIVERY_ORDER_BUYER_INVALID_LOCATION' ||
    error === 'DELIVERY_ORDER_LISTING_INVALID_LOCATION' ||
    error === 'INVALID_DELIVERY'
  ) {
    message = {
      name: 'error_invalid_place_short',
      code: 'error_invalid_place_short',
      error: 'error_invalid_place_short',
      message: 'msg_loggi_unavailable_dialog',
      type: 'address',
      origErrorCode: error,
    };
  } else if (error === 'DELIVERY_ORDER_BUYER_AND_LISTING_INVALID_LOCATION') {
    message = {
      name: 'error_invalid_place_short',
      code: 'error_invalid_place_short',
      error: 'error_invalid_place_short',
      message: 'error_delivery_estimation',
      type: 'address',
      origErrorCode: error,
    };
  } else if (error === 'DELIVERY_ORDER_ALREADY_SET') {
    message = {
      name: 'error_unknown_delivery_short',
      code: 'error_unknown_delivery_short',
      error: 'error_unknown_delivery_short',
      message: 'error_delivery_with_order',
      type: 'delivery',
      origErrorCode: error,
    };
  } //
  else if (error === 'ENTITY_NOT_FOUND') {
    message = {
      name: 'error_delivery_does_not_exist',
      code: 'error_delivery_does_not_exist',
      error: 'error_delivery_does_not_exist',
      message: 'error_updating_listing_missing',
      type: 'order',
      origErrorCode: error,
    };
  } else if (error === 'LISTING_NOT_FOUND') {
    message = {
      name: 'msg_listing_not_found',
      code: 'msg_listing_not_found',
      error: 'msg_listing_not_found',
      message: 'msg_listing_not_found',
      type: 'listing',
      origErrorCode: error,
    };
  } else if (error === 'DELIVERY_ORDER_NOT_FOUND' || error === 'Internal Server Error') {
    message = {
      name: 'msg_deleted_listing',
      code: 'msg_deleted_listing',
      error: 'msg_deleted_listing',
      message: 'error_updating_listing_missing',
      type: 'delivery',
      origErrorCode: error,
    };
  } else if (error === 'DELIVERY_ORDER_INVALID_STATE_CHANGE') {
    message = {
      name: 'error_invalid_place_short',
      code: 'error_invalid_place_short',
      error: 'error_invalid_place_short',
      message: 'error_loggi_create_delivery_long',
      type: 'delivery',
      origErrorCode: error,
    };
  } else if (
    error === 'DELIVERY_ORDER_NOT_BUYER_OR_SELLER' ||
    error === 'DELIVERY_ORDER_LOGGI_CANNOT_CREATE_ORDER' ||
    error === 'DELIVERY_ORDER_LOGGI_INVALID_CANCEL_ORDER_SERVER_REQUEST' ||
    error === 'DELIVERY_ORDER_LOGGI_CANNOT_CANCEL_ORDER' ||
    error === 'DELIVERY_ORDER_LOGGI_ORDER_NOT_FOUND' ||
    error === 'DELIVERY_ORDER_LOGGI_INVALID_ESTIMATE_PRICE_SERVER_REQUEST' ||
    error === 'DELIVERY_ORDER_LOGGI_WITHOUT_PACKAGES' ||
    error === 'DELIVERY_ORDER_LOGGI_INVALID_CREATE_ORDER_SERVER_REQUEST'
  ) {
    message = {
      name: 'error_invalid_place_long',
      code: 'error_invalid_place_long',
      error: 'error_invalid_place_long',
      message: 'error_loggi_create_delivery_long',
      type: 'delivery',
      origErrorCode: error,
    };
  } else if (
    error === 'DELIVERY_ORDER_LOGGI_CLOSED' ||
    error === 'DELIVERY_ORDER_PROVIDER_CLOSED' ||
    error === 'DELIVERY_ORDER_LOGGI_NULL_ADDRESS' ||
    error === 'DELIVERY_ORDER_CANNOT_CREATE_ORDER'
  ) {
    message = {
      name: 'error_delivery_closed_short',
      code: 'error_delivery_closed_short',
      error: 'error_delivery_closed_short',
      message: 'error_delivery_closed_long',
      type: 'provider',
      origErrorCode: error,
    };
  } else if (error === 'STRIPE_INVALID_PAYMENT_METHOD') {
    message = {
      name: 'error_card_declined',
      code: 'error_card_declined',
      error: 'error_card_declined',
      message: 'error_card_declined',
      type: 'payment',
      origErrorCode: error,
    };
  } else if (error === 'STRIPE_CANT_PERFORM_PAYMENT') {
    message = {
      name: 'error_card_declined',
      code: 'error_card_declined',
      error: 'error_card_declined',
      message: 'error_msg_payment_failed',
      type: 'payment',
      origErrorCode: error,
    };
  } else if (error === 'LISTING_INVALID_CATEGORY' || error === 'DEACTIVATED') {
    message = {
      name: 'error_invalid_product_type_title',
      code: 'error_invalid_product_type_title',
      error: 'error_invalid_product_type_title',
      message: 'error_invalid_product_type_description',
      type: 'delivery',
      origErrorCode: error,
    };
  } else if (error === 'BUYER_LISTING_ALREADY_WITH_ORDER') {
    message = {
      name: 'BUYER_LISTING_ALREADY_WITH_ORDER',
      code: 'BUYER_LISTING_ALREADY_WITH_ORDER',
      error: 'BUYER_LISTING_ALREADY_WITH_ORDER',
      message: 'BUYER_LISTING_ALREADY_WITH_ORDER',
      type: 'delivery',
      origErrorCode: error,
    };
  } else if (error === 'INVALID_LISTING_ID') {
    message = {
      name: 'INVALID_LISTING_ID',
      code: 'INVALID_LISTING_ID',
      error: 'INVALID_LISTING_ID',
      message: 'INVALID_LISTING_ID',
      type: 'listing',
      origErrorCode: error,
    };
  } else if (error === 'INVALID_ACTION') {
    message = {
      name: 'error_invalid_place_long',
      code: 'error_invalid_place_long',
      error: 'error_invalid_place_long',
      message: 'text_limit_requests',
      type: 'product',
      origErrorCode: error,
    };
  } else if (error === 'PRODUCT_OUT_OF_STOCK') {
    message = {
      name: 'label_not_available',
      code: 'label_not_available',
      error: 'label_not_available',
      message: 'text_not_available',
      type: 'product',
      origErrorCode: error,
    };
  } else if (error === 'CANT_PERFORM_PAYMENT') {
    message = {
      name: 'error_invalid_place_long',
      code: 'error_invalid_place_long',
      error: 'error_invalid_place_long',
      message: 'text_limit_requests',
      type: 'product',
      origErrorCode: error,
    };
  }

  return message;
};

// DELIVERY_ORDER_PROVIDER_CLOSED,
// DELIVERY_ORDER_CANNOT_ESTIMATE_PRICE,
// DELIVERY_ORDER_CANNOT_CANCEL_ORDER,
// DELIVERY_ORDER_NOT_IN_FAILED_STATE,
// DELIVERY_ORDER_NOT_SELLER,
// UNABLE_TO_RESTART_DELIVERY,
// UNABLE_TO_DELETE_DELIVERY,
// INVALID_DELIVERY_PROVIDER,
// REPEATED_THIRD_PARTY_ID,

export interface DeliveryApiError extends Error {
  code: string;
  error: string;
  message: string;
  type: DeliveryApiErrorType;
  origErrorCode: string;
}

export const DEFAULT_DELIVERY_API_ERROR: DeliveryApiError = {
  name: 'error_unknown_delivery_short',
  code: 'error_unknown_delivery_short',
  error: 'error_unknown_delivery_short',
  message: 'msg_unknown_delivery_error',
  type: 'delivery',
  origErrorCode: 'UNKNOWN',
};

export const parseDeliveryAPIError = (error: any): DeliveryApiError => {
  let label: DeliveryApiError = DEFAULT_DELIVERY_API_ERROR;

  if (error) {
    const parsedError = parseApiError(error);
    console.log(parsedError.code);
    label = parseDeliveryError(parsedError.code) || DEFAULT_DELIVERY_API_ERROR;
    if (error.origErrorCode) {
      label.origErrorCode = error.origErrorCode || label.origErrorCode;
    }
  }

  return label;
};
